<template>
    <div class="abnormalCausePage">
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @confirmFn="getListFn" @searchFn="getListFn" @AddFn="AddFn" @DelFn="DelFn" />
        <div class="question">
            <IconDesc :iconDesc="iconDesc"></IconDesc>
        </div>
        <div class="componentPage">
            <tablePage :tableData="tableData" :loading="loading" @choozeTableFn="choozeTableFn" @delRow="delRow"
                @editRow="editRow" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <diaLog :isShow.sync="isShow" :title="title" :scopeArrays="scopeArrays" ref="vForm" :editForm="editForm" />
    </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js';
import getRange from '@/utils/getRange.js';
import { exReasonList, exReasonsDel, exReasonDetail } from '@/api/modules/abReason.js';

import tablePage from './Table.vue';
import diaLog from './diaLog.vue';
import IconDesc from '@/components/IconDesc/IconDesc.vue';

export default {
    mixins: [mixinForm, getRange],
    components: {
        tablePage,
        diaLog,
        IconDesc
    },
    computed: {
        /** 用于表示当前登录用户属于什么类型的角色 */
        sysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            if (currentUser.sysScope && currentUser.sysAdmin) {
                //系统管理员
                return 'isSysAdmin';
            } else if (currentUser.sysScope && !currentUser.sysAdmin) {
                //系统非管理员
                return 'isSysNoAdmin';
            } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
                //非系统管理员 以及代理角色  代理角色是迭代7的需求添加
                return 'noSysIsAdmin';
            } else {
                //非系统非管理员
                return 'noSysNoAdmin';
            }
        }
    },
    data() {
        return {
            iconDesc: [
                {
                    title: $t('integration.reason_type_icon'),
                    type: 'reasonIcon'
                }
            ],
            formContent: [
                {
                    id: 3,
                    text: $t('integration.default_condition'),
                    type: 'select',
                    paramsName: 'type',
                    selectParam: [
                        {
                            value: '1',
                            label: $t('public.no')
                        },
                        {
                            value: '0',
                            label: $t('public.yes')
                        }
                    ],
                    isChooze: true
                },
                {
                    id: 1,
                    text: 'public.reason',
                    type: 'input',
                    paramsName: 'title',
                    isChooze: false
                },
                {
                    id: 2,
                    text: 'public.table_scope',
                    type: 'select',
                    paramsName: 'sceneId',
                    selectParam: [],
                    isChooze: false
                }
            ],
            SearchForm: {
                title: '',
                sceneId: '',
                type: ''
            },
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Add1',
                    method: 'AddFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Delete',
                    method: 'DelFn'
                }
            ],
            scopeArrays: [],
            tableArray: [],
            editForm: {
                title: '',
                scope: '',
                describe: ''
            }
        };
    },
    created() {
        if (this.sysAdmin === 'isSysAdmin' || this.sysAdmin === 'isSysNoAdmin') {
            this.getRangeFn();
        } else {
            this.formContent.pop();
        }
    },
    methods: {
        choozeTableFn(row) {
            this.tableArray = row;
        },
        getRangeFn() {
            this.getCustomerList({
                tab: 1
            }).then(({ result }) => {
                this.formContent[2].selectParam = result.slice(1).map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    };
                });
                this.formContent[2].selectParam.unshift({
                    value: '',
                    label: 'public.please'
                });
            });
        },
        resetFn() {
            (this.SearchForm = {
                title: '',
                sceneId: '',
                iDisplayStart: 0,
                iDisplayLength: 15
            }),
                this.getListFn();
        },
        getListFn() {
            this.loading = true;
            exReasonList(this.SearchForm)
                .then(({ result, pageInfo }) => {
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        optareRange() {
            if (this.scopeArrays.length > 0) return;
            this.getCustomerList({ tab: 1 }).then(({ result }) => {
                this.scopeArrays = result.slice(1);
                this.scopeArrays.forEach(item => {
                    item.id = parseInt(item.id);
                });
                console.log(this.scopeArrays);
            });
        },
        AddFn() {
            this.isShow = true;
            this.title = $t('integration.add_exception_reason_definition');
            this.editForm = {
                title: '',
                scope: '',
                describe: ''
            };
            this.optareRange();
            // 这里的接口范围请求 暂时不做合并
            this.$nextTick(() => {
                this.$refs['vForm'].clearValidate();
            });
        },
        // 删除
        DelFn() {
            if (this.tableArray.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let ids = this.tableArray.map(item => item.id);
            this.TODOTIPDEL(ids);
        },
        /** 单条删除 */
        delRow(row) {
            let ids = [row.id];
            this.TODOTIPDEL(ids);
        },
        /**
         *
         * @param {*param 选中数据id} param string
         */
        TODOTIPDEL(param) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'))
                .then(() => {
                    exReasonsDel(param).then(({ result, state }) => {
                        if (result === 1) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        } else if (result === 2) {
                            this.$message.error($t('integration.the_last_piece_of_data_cannot_be_deleted'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => { });
        },
        /** 编辑 */
        editRow(row) {
            this.isShow = true;
            this.title = $t('integration.edit') + `-[${row.title}]`;
            this.optareRange();
            exReasonDetail({ id: row.id }).then(({ result }) => {
                delete result.createTime;
                this.editForm = result;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.abnormalCausePage {
    height: 100%;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;

    .question {
        position: absolute;
        right: 15px;
        top: 75px;
        font-size: 18px;
        cursor: pointer;
        color: #9bccfd;

        &:hover {
            color: var(--primary-color);
        }
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }

    ::v-deep .el-textarea__inner {
        border-radius: 2px;
        // margin-left: 5px;
    }
}
</style>
